<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L4 2.58579L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L4.70711 4.70711C4.31658 5.09763 3.68342 5.09763 3.29289 4.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAngle",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "8"
    }
  }
};
</script>
